import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const Reviews = () => {
    return (_jsx("a", { className: "yotpo yotpo-shoppers-say", "data-product-id": "protein", href: "/reviews", children: "\u00A0" }));
};
export default Reviews;
